import React from 'react';
import { Navigate } from 'react-router-dom';

import getJourneyRoute from './getJourneyRoute';

/*
 * NOTE: the route can different than the journeyId.
 * for example - the login route is "/#/login" but the journeyId could be 'avLogin'.
 * need to check if the journeyId doesn't map out to the current route and then navigate to the correct route if necessary.
 */
const checkNavigation = (journeyId, currentRoute) => {
  // check for correct journeyRoute against the current journeyId;
  const routeToUse = getJourneyRoute(journeyId);

  // if correct journeyRoute does not match the currentRoute, navigate to the correct route.
  if (routeToUse !== currentRoute) {
    return <Navigate to={`/${routeToUse}`} replace />;
  }
  return false;
};

export default checkNavigation;
